
import { AuthService, CompanyService } from "@/services";
import { MailSettingsService } from "@/services/mail-settings-service";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";

interface Settings {
	settingsId:number;
	user:string;
	settingsName:string;
	displayName:string;
}


export default Vue.extend({
	data(){
		return {
			input: "",
			settings: [] as Settings[]
		};
	},
	props: {
		fancy: Boolean,
		label: {
			type: [Object as ()=>TranslateResult, String]
		},
		value: {
			type: [Number]
		},
		addEmptyValue: Boolean,
		emptyText: [Object as ()=>TranslateResult, String],
		disabled: Boolean,
		up: Boolean
	},
	computed: {
		shownItems():ISelectItem<Settings | null>[]{
			return this.items.filter(i=>{
				return i.text.toString().toLowerCase().indexOf(this.input.toLowerCase()) != -1;
			});
		},
		selectedValue():Settings | null{
			if (!this.value) return null;
			return this.settings.find(s=>s.settingsId == this.value) || null;
		},
		nullValueText():TranslateResult | string {
			if (this.emptyText) {
				return this.emptyText;
			}
			return this.$ct("common.none");
		},
		items():ISelectItem<Settings | null>[]{
			let allSettings:ISelectItem<Settings | null>[] = this.settings.map(s=>{
				return {
					text: s.displayName,
					value: s
				} as ISelectItem<Settings>;
			});
			if (this.addEmptyValue){
				allSettings.unshift({
					text: this.nullValueText,
					value: null
				});
			}
			return allSettings;
		}
	},
	methods: {
		setValue(val:ISelectItem<Settings | null>){
			console.log("Setting value", val);
			if (!val || !val.value) {
				this.input = "";
				return this.$emit("input", null);
			}
			this.input = val.value.displayName;
			return this.$emit("input", val.value.settingsId);
		},
		onBlur(){
			if (this.selectedValue){
				this.input = this.selectedValue.displayName;
			}else{
				this.input = this.nullValueText.toString();
			}
		},
		onFocus(){
			this.input = "";
		}
	},
	async mounted(){
		let settings = await MailSettingsService.getAllUsersSettings();
		let users = await CompanyService.getUsers();
		let allSettings = settings.map((s)=>{
			let user = users.find(u=>u.ID == s.UserID);
			if (!user){
				return null;
			}
			let displayName = s.Label;
			if (AuthService.wfUser.ID != s.ID){
				displayName = `${s.Label} (${user.getShortDisplayName()})`;
			}
			return {
				settingsId: s.ID,
				settingsName: s.Label,
				user: user.getShortDisplayName(),
				displayName
			};
		});
		this.settings = allSettings.filter(s=>s!=null) as any as Settings[];
		if (this.selectedValue) {
			this.input = this.selectedValue.displayName;
		}
	}
});
